// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"4935dd07","508":"df5deb1a","776":"0b7fa892"}[chunkId] + ".chunk.js";
};